import { db } from "@/firebaseConfig";

const productTypesCollection = db.collection("product_types");

const saveProductTypeCart = async (id, data) => {
  productTypesCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("ProductTypeCart successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateProductTypeCart = async (id, data) => {
  productTypesCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("ProductTypeCart successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteProductTypeCart = async id => {
  productTypesCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("ProductTypeCart successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getProductTypeCartById = async id => {
  return productTypesCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  productTypesCollection,
  saveProductTypeCart,
  updateProductTypeCart,
  deleteProductTypeCart,
  getProductTypeCartById
};
